import company from './components/company';
import sideNav from './components/sideNav';
import workModal from './components/workModal';
import workMenu from './components/workMenu';
import ajaxZip from './components/ajaxZip';
import cbToggle from './components/cbToggle';
import checkBox from './components/checkBox';

document.addEventListener(
  'DOMContentLoaded',
  () => {
    const companyPage = document.querySelector('.company');
    if (companyPage) {
      company();
    }
    sideNav();
    workModal();
    workMenu();
    ajaxZip();
    cbToggle();
    checkBox();
  },
  false
);
